/* CLEAR OIL — ポリシーページの本文を段落に組み直す。

   Shopify が自動生成する利用規約は、本文まるごとが 1 つの <p> で、
   段落の切れ目も節見出しも <br> と <strong> だけで表現されている
   （実測：<br> 115 個、<strong> 26 個。26 個すべてが行頭かつ直後が <br>）。
   要素になっていないので CSS では段落間の余白を作れない
   （br { display:block; margin } は Chrome で余白にならない）。

   そこで読み込み時に <h2> と <p> に組み直す。文言は一切変えない。
   JS が動かない場合は元のまま表示され、co-policy.css の
   `.rte > p:only-child strong` が見出しだけ立てるフォールバックになる。

   自前で用意したポリシー（特商法・配送・返金）や、<h2> と <ul> を持つ
   プライバシーポリシーは初めから構造化されているので、この処理は素通りする。 */
(function () {
  'use strict';

  function init() {
    var rte = document.querySelector('.shopify-policy__body .rte');
    if (!rte) return;

    // 対象は「本文が <p> ひとつだけ」のページに限る
    if (rte.children.length !== 1) return;
    var source = rte.firstElementChild;
    if (source.tagName !== 'P') return;
    if (!source.querySelector('br')) return;

    // <br> で区切って行に分ける
    var lines = [];
    var line = [];
    Array.prototype.forEach.call(source.childNodes, function (node) {
      if (node.nodeType === 1 && node.tagName === 'BR') {
        lines.push(line);
        line = [];
      } else {
        line.push(node);
      }
    });
    lines.push(line);

    function textOf(nodes) {
      return nodes
        .map(function (n) { return n.textContent; })
        .join('')
        .trim();
    }

    // 中身が <strong> ひとつだけの行＝節見出し
    function headingText(nodes) {
      var elements = nodes.filter(function (n) {
        return n.nodeType === 1 || (n.nodeType === 3 && n.textContent.trim());
      });
      if (elements.length !== 1) return null;
      var only = elements[0];
      if (only.nodeType !== 1 || only.tagName !== 'STRONG') return null;
      return only.textContent.trim();
    }

    var out = document.createDocumentFragment();
    var made = 0;

    lines.forEach(function (nodes) {
      if (!textOf(nodes)) return; // 空行は捨てる（余白は CSS で作る）

      var heading = headingText(nodes);
      if (heading) {
        var h = document.createElement('h2');
        h.textContent = heading;
        out.appendChild(h);
      } else {
        var p = document.createElement('p');
        nodes.forEach(function (n) { p.appendChild(n.cloneNode(true)); });
        out.appendChild(p);
      }
      made++;
    });

    if (made < 2) return; // 組み直す意味がないときは触らない
    rte.replaceChild(out, source);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
